export interface Movie {
  id: string;
  title: string;
  channel: string;
  genres: string[];
  region: string;
  year: number;
  score: number;
  episodes: number;
  episodeUnit: string;
  updateStatus: string;
  director: string;
  cast: string[];
  synopsis: string;
  cover: string;
  banner: string;
  tags: string[];
  popularity: number;
  updatedAt: string;
  featured: boolean;
}

export const movies: Movie[] = [
  {
    id: "d1",
    title: "星辰大海",
    channel: "电视剧",
    genres: ["都市", "励志"],
    region: "中国大陆",
    year: 2025,
    score: 9.1,
    episodes: 40,
    episodeUnit: "集",
    updateStatus: "更新至40集 全剧完结",
    director: "沈知远",
    cast: ["林知夏", "顾南屿", "苏晚", "陆时"],
    synopsis:
      "小镇青年怀揣蔚蓝梦想闯荡大都市，在一次次浪潮与抉择中，把平凡生活过成了自己的星辰大海。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20for%20a%20modern%20urban%20inspirational%20Chinese%20drama%2C%20young%20protagonist%20looking%20toward%20a%20glowing%20city%20skyline%20at%20blue%20hour%2C%20warm%20orange%20courtyard%20lights%2C%20rich%20color%20grading%2C%20high%20detail%20film%20poster%20aesthetic%2C%20clean%20composition&width=600&height=900&seq=mgtv-d1-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20for%20a%20modern%20urb%20inspirational%20drama%2C%20young%20person%20silhouette%20before%20a%20vibrant%20metropolitan%20skyline%20at%20sunset%2C%20warm%20orange%20and%20amber%20glow%20with%20deep%20shadows%2C%20moody%20atmosphere%2C%20high%20detail%20editorial%20key%20art&width=1600&height=900&seq=mgtv-d1-banner&orientation=landscape",
    tags: ["都市梦想", "热血成长", "口碑佳作"],
    popularity: 982000,
    updatedAt: "2025-09-28",
    featured: true,
  },
  {
    id: "d2",
    title: "长安夜行录",
    channel: "电视剧",
    genres: ["古装", "悬疑"],
    region: "中国大陆",
    year: 2025,
    score: 8.9,
    episodes: 36,
    episodeUnit: "集",
    updateStatus: "更新至36集 全剧完结",
    director: "顾清和",
    cast: ["白慕言", "温暖", "柯岩", "沈墨"],
    synopsis:
      "长安城接连发生离奇谜案，年轻推官与神秘画师联手追查，一层层揭开盛世灯火下的隐秘往事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20for%20an%20ancient%20Chinese%20mystery%20drama%2C%20lantern%20lit%20peking%20style%20city%20street%20at%20night%2C%20figure%20in%20flowing%20hanfu%20holding%20a%20lantern%2C%20misty%20moonlight%2C%20deep%20teal%20and%20gold%20tones%2C%20high%20detail%20period%20film%20aesthetic&width=600&height=900&seq=mgtv-d2-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20for%20an%20ancient%20Chinese%20mystery%20drama%2C%20misty%20night%20over%20a%20grand%20traditional%20city%20with%20glowing%20lanterns%20and%20temple%20roofs%2C%20deep%20teal%20and%20warm%20gold%20atmosphere%2C%20dramatic%20lighting%2C%20high%20detail%20key%20art&width=1600&height=900&seq=mgtv-d2-banner&orientation=landscape",
    tags: ["古装探案", "悬疑烧脑", "唯美视觉"],
    popularity: 915000,
    updatedAt: "2025-09-20",
    featured: true,
  },
  {
    id: "d3",
    title: "山海拾光",
    channel: "电视剧",
    genres: ["奇幻", "爱情"],
    region: "中国大陆",
    year: 2024,
    score: 8.6,
    episodes: 32,
    episodeUnit: "集",
    updateStatus: "更新至32集 全剧完结",
    director: "苏青",
    cast: ["黎锦", "许安", "陈望", "温以宁"],
    synopsis:
      "传说山海之间藏着能拾回逝去时光的秘境，一位少女与守山人跨越千年的相逢，就此展开。",
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20romance%20vertical%20poster%20for%20a%20Chinese%20xianxia%20drama%2C%20ethereal%20young%20woman%20in%20floating%20silk%20robes%20before%20misty%20mountains%20and%20sea%20of%20clouds%2C%20glowing%20spirit%20light%2C%20pastel%20and%20jade%20tones%2C%20high%20detail%20fantasy%20key%20art&width=600&height=900&seq=mgtv-d3-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20fantasy%20banner%20for%20a%20Chinese%20xianxia%20romance%20drama%2C%20floating%20islands%20above%20a%20sea%20of%20clouds%20at%20dawn%2C%20ethereal%20pastel%20pink%20and%20jade%20green%20light%2C%20mystical%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=mgtv-d3-banner&orientation=landscape",
    tags: ["奇幻仙恋", "唯美画风", "千年之约"],
    popularity: 876000,
    updatedAt: "2025-08-30",
    featured: false,
  },
  {
    id: "d4",
    title: "都市迷城",
    channel: "电视剧",
    genres: ["都市", "悬疑"],
    region: "中国大陆",
    year: 2025,
    score: 8.7,
    episodes: 24,
    episodeUnit: "集",
    updateStatus: "更新至24集 全剧完结",
    director: "韩川",
    cast: ["周未然", "苏清", "陆星野", "林晚晴"],
    synopsis:
      "一桩看似普通的失踪案，牵出城市光鲜表面之下的层层迷局，真相往往藏在最不起眼的角落。",
    cover:
      "https://readdy.ai/api/search-image?query=Neo%20noir%20vertical%20poster%20for%20a%20modern%20urban%20thriller%20Chinese%20drama%2C%20lone%20figure%20in%20a%20rainy%20neon%20lit%20city%20alley%2C%20reflections%20on%20wet%20asphalt%2C%20cold%20teal%20and%20amber%20contrast%2C%20cinematic%20high%20detail%20key%20art&width=600&height=900&seq=mgtv-d4-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20neo%20noir%20banner%20for%20an%20urban%20mystery%20drama%2C%20rainy%20metropolis%20skyline%20at%20night%20with%20reflected%20street%20lights%2C%20cold%20blue%20with%20warm%20highlights%2C%20tense%20cinematic%20mood%2C%20high%20detail%20key%20art&width=1600&height=900&seq=mgtv-d4-banner&orientation=landscape",
    tags: ["都市悬疑", "烧脑推理", "氛围感强"],
    popularity: 842000,
    updatedAt: "2025-09-15",
    featured: true,
  },
  {
    id: "d5",
    title: "时光信笺",
    channel: "电视剧",
    genres: ["青春", "爱情"],
    region: "中国大陆",
    year: 2024,
    score: 8.4,
    episodes: 28,
    episodeUnit: "集",
    updateStatus: "更新至28集 全剧完结",
    director: "温雅",
    cast: ["夏栀", "江遥", "沈砚", "白露"],
    synopsis:
      "一封迟到了十年的信，让两个曾经错过的人，在城市的两端重新读懂了青春与遗憾。",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20nostalgic%20vertical%20poster%20for%20a%20Chinese%20youth%20romance%20drama%2C%20young%20couple%20on%20a%20sunlit%20campus%20with%20floating%20letters%2C%20warm%20sepia%20and%20gentle%20pastel%20tones%2C%20dreamy%20bokeh%2C%20heartfelt%20film%20poster%20aesthetic&width=600&height=900&seq=mgtv-d5-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20warm%20nostalgic%20banner%20for%20a%20Chinese%20youth%20romance%20drama%2C%20sunlit%20school%20campus%20path%20with%20trees%20and%20soft%20light%20rays%2C%20warm%20golden%20and%20gentle%20pastel%20tones%2C%20dreamy%20romantic%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-d5-banner&orientation=landscape",
    tags: ["青春校园", "治愈爱情", "催泪"],
    popularity: 731000,
    updatedAt: "2025-07-18",
    featured: false,
  },
  {
    id: "d6",
    title: "破晓而来",
    channel: "电视剧",
    genres: ["谍战", "年代"],
    region: "中国大陆",
    year: 2025,
    score: 9.0,
    episodes: 42,
    episodeUnit: "集",
    updateStatus: "更新至42集 全剧完结",
    director: "程岳",
    cast: ["江屿", "沈知白", "苏岸", "陈默"],
    synopsis:
      "风雨如晦的年代里，一群隐于暗处的无名者，用信念在黎明之前劈开了一条通往光明的路。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20for%20a%20Chinese%20period%20spy%20drama%2C%20elegant%20figure%20in%20a%20vintage%20trench%20coat%20under%20warm%20lamplight%20in%20a%20rainy%20old%20city%20street%2C%20muted%20teal%20and%20sepia%20tones%2C%20tense%20cinematic%20mood%2C%20high%20detail&width=600&height=900&seq=mgtv-d6-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20for%20a%20Chinese%20period%20spy%20drama%2C%20rainy%20old%20city%20street%20at%20dusk%20with%20warm%20lamps%20and%20fog%2C%20muted%20teal%20and%20sepia%20tone%2C%20tense%20dramatic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=mgtv-d6-banner&orientation=landscape",
    tags: ["谍战风云", "家国情怀", "群像大剧"],
    popularity: 806000,
    updatedAt: "2025-09-05",
    featured: false,
  },
  {
    id: "d7",
    title: "医心仁术",
    channel: "电视剧",
    genres: ["医疗", "职场"],
    region: "中国大陆",
    year: 2024,
    score: 8.5,
    episodes: 30,
    episodeUnit: "集",
    updateStatus: "更新至30集 全剧完结",
    director: "叶楠",
    cast: ["齐衡", "苏晚", "林知远", "何静"],
    synopsis:
      "急诊室里的每一秒都在与命运赛跑，一群年轻医者用专业与温度，守护着每一次心跳。",
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20modern%20vertical%20poster%20for%20a%20Chinese%20medical%20drama%2C%20focused%20doctor%20in%20scrubs%20under%20bright%20clinical%20light%2C%20calm%20blue%20white%20tones%20with%20warm%20accents%2C%20professional%20editorial%20film%20poster%20aesthetic%2C%20high%20detail&width=600&height=900&seq=mgtv-d7-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20modern%20banner%20for%20a%20Chinese%20medical%20drama%2C%20bright%20hospital%20corridor%20with%20soft%20daylight%20and%20clean%20lines%2C%20calm%20blue%20white%20tones%20with%20warm%20accents%2C%20professional%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-d7-banner&orientation=landscape",
    tags: ["医疗职场", "群像温情", "正能量"],
    popularity: 688000,
    updatedAt: "2025-06-30",
    featured: false,
  },
  {
    id: "d8",
    title: "江湖小客栈",
    channel: "电视剧",
    genres: ["武侠", "喜剧"],
    region: "中国大陆",
    year: 2025,
    score: 8.3,
    episodes: 26,
    episodeUnit: "集",
    updateStatus: "更新至26集 全剧完结",
    director: "莫言秋",
    cast: ["唐小叶", "老白", "阿七", "沈刀"],
    synopsis:
      "一间开在官道旁的江湖小客栈，来来往往的客人个个身怀故事，笑料与刀光同样精彩。",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20vertical%20poster%20for%20a%20Chinese%20wuxia%20comedy%20drama%2C%20cozy%20old%20roadside%20inn%20with%20warm%20lanterns%2C%20quirky%20martial%20artists%20gathered%20around%20a%20table%2C%20warm%20amber%20and%20jade%20tones%2C%20high%20detail%20illustrated%20key%20art&width=600&height=900&seq=mgtv-d8-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20warm%20banner%20for%20a%20Chinese%20wuxia%20comedy%20drama%2C%20cozy%20old%20roadside%20inn%20at%20dusk%20with%20glowing%20lanterns%20and%20green%20mountains%20behind%2C%20warm%20amber%20and%20jade%20tones%2C%20playful%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-d8-banner&orientation=landscape",
    tags: ["武侠喜剧", "轻松下饭", "群像"],
    popularity: 612000,
    updatedAt: "2025-08-12",
    featured: false,
  },
  {
    id: "d9",
    title: "我们的教室",
    channel: "电视剧",
    genres: ["校园", "青春"],
    region: "中国大陆",
    year: 2024,
    score: 8.2,
    episodes: 24,
    episodeUnit: "集",
    updateStatus: "更新至24集 全剧完结",
    director: "林清欢",
    cast: ["夏禾", "周予", "安然", "陆鸣"],
    synopsis:
      "高三那年，一群少年在同一间教室里奔跑、迷茫、和解，把最明亮的时光留在了彼此身边。",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20warm%20vertical%20poster%20for%20a%20Chinese%20high%20school%20youth%20drama%2C%20students%20in%20a%20sunlit%20classroom%20with%20dust%20motes%20in%20light%2C%20warm%20golden%20and%20fresh%20green%20tones%2C%20heartfelt%20film%20poster%20aesthetic%2C%20high%20detail&width=600&height=900&seq=mgtv-d9-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20bright%20banner%20for%20a%20Chinese%20high%20school%20youth%20drama%2C%20sunlit%20classroom%20with%20rows%20of%20desks%20and%20a%20large%20window%2C%20warm%20golden%20light%20and%20fresh%20green%20tones%2C%20nostalgic%20warm%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-d9-banner&orientation=landscape",
    tags: ["青春校园", "治愈成长", "回忆杀"],
    popularity: 574000,
    updatedAt: "2025-05-22",
    featured: false,
  },
  {
    id: "d10",
    title: "落日里的家",
    channel: "电视剧",
    genres: ["家庭", "伦理"],
    region: "中国大陆",
    year: 2025,
    score: 8.8,
    episodes: 34,
    episodeUnit: "集",
    updateStatus: "更新至34集 全剧完结",
    director: "郑长安",
    cast: ["柳如烟", "陈建国", "周慧", "小满"],
    synopsis:
      "三代同堂的老屋里，藏着说不出口的爱与误会，一顿顿寻常晚饭，慢慢炖出了家的味道。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20emotional%20vertical%20poster%20for%20a%20Chinese%20family%20drama%2C%20three%20generations%20gathered%20at%20a%20cozy%20dinner%20table%20under%20soft%20lamp%20light%2C%20warm%20amber%20and%20cream%20tones%2C%20tender%20heartfelt%20film%20poster%20aesthetic%2C%20high%20detail&width=600&height=900&seq=mgtv-d10-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20warm%20banner%20for%20a%20Chinese%20family%20drama%2C%20cozy%20old%20courtyard%20home%20at%20golden%20sunset%20with%20steaming%20dinner%20table%2C%20warm%20amber%20and%20cream%20tones%2C%20tender%20emotional%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-d10-banner&orientation=landscape",
    tags: ["家庭温情", "现实题材", "催泪"],
    popularity: 795000,
    updatedAt: "2025-09-25",
    featured: false,
  },
  {
    id: "v1",
    title: "周五嗨翻天",
    channel: "综艺",
    genres: ["音乐", "真人秀"],
    region: "中国大陆",
    year: 2025,
    score: 8.7,
    episodes: 16,
    episodeUnit: "期",
    updateStatus: "更新至第16期",
    director: "黄小磊",
    cast: ["何欢", "嘉宾团", "阿乐", "小北"],
    synopsis:
      "每周五晚的快乐充电站，明星嘉宾同台互动、即兴开唱，把一周的疲惫统统嗨掉。",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20energetic%20vertical%20poster%20for%20a%20Chinese%20music%20variety%20show%2C%20colorful%20stage%20with%20glowing%20lights%20and%20confetti%2C%20joyful%20performers%20mid%20celebration%2C%20vivid%20orange%20pink%20and%20purple%20stage%20lights%2C%20high%20energy%20key%20art&width=600&height=900&seq=mgtv-v1-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20vibrant%20banner%20for%20a%20Chinese%20music%20variety%20show%2C%20dazzling%20concert%20stage%20with%20beam%20lights%20and%20a%20large%20cheering%20audience%2C%20vivid%20orange%20and%20magenta%20stage%20lights%2C%20high%20energy%20festive%20atmosphere&width=1600&height=900&seq=mgtv-v1-banner&orientation=landscape",
    tags: ["音乐综艺", "欢乐治愈", "每周更新"],
    popularity: 903000,
    updatedAt: "2025-10-10",
    featured: true,
  },
  {
    id: "v2",
    title: "田园慢生活",
    channel: "综艺",
    genres: ["生活", "纪实"],
    region: "中国大陆",
    year: 2025,
    score: 8.9,
    episodes: 12,
    episodeUnit: "期",
    updateStatus: "更新至第12期",
    director: "田牧",
    cast: ["舒然", "阿谷", "小院一家人"],
    synopsis:
      "远离城市喧嚣，在一方小院里种菜、做饭、看云卷云舒，把日子过成慢下来的诗。",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20pastoral%20vertical%20poster%20for%20a%20Chinese%20slow%20living%20reality%20show%2C%20sunlit%20countryside%20farmhouse%20with%20vegetable%20garden%20and%20wooden%20fence%2C%20soft%20green%20and%20cream%20tones%2C%20peaceful%20natural%20atmosphere%2C%20high%20detail&width=600&height=900&seq=mgtv-v2-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20serene%20banner%20for%20a%20Chinese%20slow%20living%20reality%20show%2C%20lush%20green%20countryside%20village%20at%20golden%20hour%20with%20mountains%20and%20fields%2C%20soft%20green%20and%20warm%20cream%20tones%2C%20peaceful%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-v2-banner&orientation=landscape",
    tags: ["治愈慢综", "田园纪实", "下饭首选"],
    popularity: 856000,
    updatedAt: "2025-10-08",
    featured: false,
  },
  {
    id: "v3",
    title: "厨神请下厨",
    channel: "综艺",
    genres: ["美食", "竞技"],
    region: "中国大陆",
    year: 2025,
    score: 8.5,
    episodes: 14,
    episodeUnit: "期",
    updateStatus: "更新至第14期",
    director: "郑味",
    cast: ["主厨天团", "味蕾评审团"],
    synopsis:
      "顶尖厨师同台竞技，一道菜里见真章。灶火之间，是对食材最大的尊重与热爱。",
    cover:
      "https://readdy.ai/api/search-image?query=Appetizing%20warm%20vertical%20poster%20for%20a%20Chinese%20culinary%20competition%20show%2C%20chef%20flambe%20in%20a%20professional%20kitchen%20with%20sizzling%20pans%2C%20rich%20orange%20and%20deep%20amber%20tones%2C%20dynamic%20mouthwatering%20food%20photography%20aesthetic%2C%20high%20detail&width=600&height=900&seq=mgtv-v3-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20appetizing%20banner%20for%20a%20Chinese%20culinary%20competition%20show%2C%20dramatic%20professional%20kitchen%20with%20steaming%20dishes%20and%20warm%20firelight%2C%20rich%20orange%20and%20deep%20amber%20tones%2C%20dynamic%20mouthwatering%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-v3-banner&orientation=landscape",
    tags: ["美食竞技", "下饭神器", "高手过招"],
    popularity: 764000,
    updatedAt: "2025-09-30",
    featured: false,
  },
  {
    id: "v4",
    title: "一路向北",
    channel: "综艺",
    genres: ["旅行", "户外"],
    region: "中国大陆",
    year: 2024,
    score: 8.4,
    episodes: 10,
    episodeUnit: "期",
    updateStatus: "更新至第10期",
    director: "向北",
    cast: ["沈行", "搭档团", "路一"],
    synopsis:
      "一群好友驾车上路，一路向北穿越山川湖海，在旅途中重新认识世界与自己。",
    cover:
      "https://readdy.ai/api/search-image?query=Adventurous%20vertical%20poster%20for%20a%20Chinese%20travel%20reality%20show%2C%20friends%20beside%20an%20off%20road%20car%20on%20a%20winding%20mountain%20road%2C%20vast%20wilderness%20and%20dramatic%20clouds%2C%20cool%20blue%20and%20warm%20earth%20tones%2C%20high%20detail%20key%20art&width=600&height=900&seq=mgtv-v4-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20adventurous%20banner%20for%20a%20Chinese%20travel%20reality%20show%2C%20sweeping%20mountain%20highway%20cutting%20through%20vast%20landscape%20under%20dramatic%20sky%2C%20cool%20blue%20and%20warm%20earth%20tones%2C%20free%20spirited%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-v4-banner&orientation=landscape",
    tags: ["旅行综艺", "公路之旅", "解压"],
    popularity: 623000,
    updatedAt: "2025-04-15",
    featured: false,
  },
  {
    id: "v5",
    title: "笑声不打烊",
    channel: "综艺",
    genres: ["喜剧", "脱口秀"],
    region: "中国大陆",
    year: 2025,
    score: 8.6,
    episodes: 18,
    episodeUnit: "期",
    updateStatus: "更新至第18期",
    director: "笑笑",
    cast: ["脱口秀夜班", "嘉宾阵容"],
    synopsis:
      "深夜不打烊的喜剧舞台，用一个个段子拆解生活的荒诞与可爱，笑着笑着就治愈了。",
    cover:
      "https://readdy.ai/api/search-image?query=Fun%20club%20vertical%20poster%20for%20a%20Chinese%20stand%20up%20comedy%20show%2C%20comedian%20with%20microphone%20on%20a%20warm%20spotlit%20stage%2C%20playful%20light%20bulbs%20and%20brick%20wall%2C%20warm%20orange%20and%20deep%20red%20tones%2C%20high%20detail%20key%20art&width=600&height=900&seq=mgtv-v5-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20warm%20banner%20for%20a%20Chinese%20stand%20up%20comedy%20show%2C%20cozy%20night%20club%20stage%20with%20spotlight%20and%20sitting%20audience%2C%20warm%20orange%20and%20deep%20red%20tones%2C%20playful%20inviting%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-v5-banner&orientation=landscape",
    tags: ["脱口秀", "爆笑解压", "段子合集"],
    popularity: 712000,
    updatedAt: "2025-10-05",
    featured: false,
  },
  {
    id: "v6",
    title: "舞台新声代",
    channel: "综艺",
    genres: ["选秀", "音乐"],
    region: "中国大陆",
    year: 2025,
    score: 8.3,
    episodes: 20,
    episodeUnit: "期",
    updateStatus: "更新至第20期",
    director: "音你而来",
    cast: ["新生代歌手", "导师团"],
    synopsis:
      "为热爱音乐的新生力量提供舞台，从素人到聚光灯下，每一首歌都是梦想的注脚。",
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20stage%20vertical%20poster%20for%20a%20Chinese%20music%20talent%20show%2C%20young%20singer%20bathed%20in%20a%20single%20spotlight%20on%20a%20grand%20stage%2C%20glowing%20particles%20and%20deep%20blue%20violet%20lights%2C%20inspiring%20cinematic%20key%20art%2C%20high%20detail&width=600&height=900&seq=mgtv-v6-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20dreamy%20banner%20for%20a%20Chinese%20music%20talent%20show%2C%20grand%20dark%20stage%20with%20glowing%20spotlights%20and%20a%20silhouette%20of%20a%20singer%2C%20deep%20blue%20violet%20and%20warm%20white%20lights%2C%20inspiring%20cinematic%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-v6-banner&orientation=landscape",
    tags: ["音乐选秀", "青春励志", "见证成长"],
    popularity: 655000,
    updatedAt: "2025-09-18",
    featured: false,
  },
  {
    id: "m1",
    title: "孤岛回声",
    channel: "电影",
    genres: ["悬疑", "惊悚"],
    region: "中国大陆",
    year: 2025,
    score: 8.6,
    episodes: 1,
    episodeUnit: "部",
    updateStatus: "已上线",
    director: "陆沉",
    cast: ["江屿", "苏清", "白默"],
    synopsis: "一场大雾困住孤岛灯塔，三名陌生人在此醒来，各自的记忆碎片拼出一个惊人的真相。",
    cover:
      "https://readdy.ai/api/search-image?query=Chilling%20vertical%20movie%20poster%20for%20a%20Chinese%20suspense%20thriller%2C%20lonely%20lighthouse%20on%20a%20foggy%20rocky%20island%20at%20night%2C%20single%20beam%20of%20light%20cutting%20the%20mist%2C%20cold%20teal%20and%20grey%20tones%2C%20tense%20cinematic%20key%20art%2C%20high%20detail&width=600&height=900&seq=mgtv-m1-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20for%20a%20Chinese%20suspense%20thriller%20film%2C%20misty%20rocky%20coastline%20with%20a%20lighthouse%20under%20moonlight%20and%20crashing%20waves%2C%20cold%20teal%20and%20grey%20tones%2C%20tense%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=mgtv-m1-banner&orientation=landscape",
    tags: ["悬疑惊悚", "烧脑反转", "密闭空间"],
    popularity: 888000,
    updatedAt: "2025-09-22",
    featured: true,
  },
  {
    id: "m2",
    title: "追风少年",
    channel: "电影",
    genres: ["运动", "励志"],
    region: "中国大陆",
    year: 2024,
    score: 8.4,
    episodes: 1,
    episodeUnit: "部",
    updateStatus: "已上线",
    director: "风起",
    cast: ["小北", "陈阳", "林越"],
    synopsis: "一个被所有人看轻的少年，在自行车赛道上拼命蹬出属于自己的风，也蹬开了命运的门。",
    cover:
      "https://readdy.ai/api/search-image?query=Dynamic%20vertical%20movie%20poster%20for%20a%20Chinese%20sports%20inspirational%20film%2C%20young%20cyclist%20racing%20at%20high%20speed%20with%20motion%20blur%20on%20a%20coastal%20road%2C%20bright%20sunlight%20and%20vivid%20colors%2C%20high%20energy%20cinematic%20key%20art%2C%20high%20detail&width=600&height=900&seq=mgtv-m2-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20dynamic%20banner%20for%20a%20Chinese%20sports%20inspirational%20film%2C%20cyclists%20racing%20along%20a%20coastal%20road%20at%20golden%20sunset%20with%20motion%20blur%2C%20bright%20vivid%20colors%2C%20high%20energy%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-m2-banner&orientation=landscape",
    tags: ["运动励志", "热血青春", "燃"],
    popularity: 702000,
    updatedAt: "2025-07-02",
    featured: false,
  },
  {
    id: "m3",
    title: "云上之城",
    channel: "电影",
    genres: ["科幻", "冒险"],
    region: "中国大陆",
    year: 2025,
    score: 8.8,
    episodes: 1,
    episodeUnit: "部",
    updateStatus: "已上线",
    director: "未来纪元",
    cast: ["陆星野", "沈知白", "何初"],
    synopsis: "当大地不再宜居，人类将城市建在云端。一名年轻工程师发现了这座天空之城维系运转的秘密。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20vertical%20sci%20fi%20movie%20poster%20for%20a%20Chinese%20adventure%20film%2C%20futuristic%20floating%20city%20among%20giant%20clouds%20above%20a%20planet%2C%20glowing%20sky%20lanes%20and%20sleek%20architecture%2C%20cool%20cyan%20and%20warm%20amber%20accents%2C%20high%20detail%20cinematic%20key%20art&width=600&height=900&seq=mgtv-m3-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20epic%20sci%20fi%20banner%20for%20a%20Chinese%20adventure%20film%2C%20futuristic%20floating%20city%20in%20a%20sea%20of%20clouds%20at%20dawn%20with%20glowing%20sky%20lanes%2C%20cool%20cyan%20and%20warm%20amber%20accents%2C%20vast%20cinematic%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-m3-banner&orientation=landscape",
    tags: ["科幻巨制", "视觉奇观", "冒险"],
    popularity: 934000,
    updatedAt: "2025-09-28",
    featured: true,
  },
  {
    id: "m4",
    title: "归途列车",
    channel: "电影",
    genres: ["剧情", "公路"],
    region: "中国大陆",
    year: 2024,
    score: 8.5,
    episodes: 1,
    episodeUnit: "部",
    updateStatus: "已上线",
    director: "返乡",
    cast: ["老周", "小满", "林知远"],
    synopsis: "一列开往故乡的绿皮火车，载着形形色色的旅人，也载着每个人各自的牵挂与和解。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20vertical%20movie%20poster%20for%20a%20Chinese%20road%20drama%2C%20green%20train%20crossing%20golden%20fields%20at%20sunset%20with%20warm%20window%20light%2C%20soft%20amber%20and%20cream%20tones%2C%20tender%20cinematic%20key%20art%2C%20high%20detail&width=600&height=900&seq=mgtv-m4-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20warm%20nostalgic%20banner%20for%20a%20Chinese%20road%20drama%20film%2C%20old%20green%20train%20traveling%20through%20golden%20autumn%20fields%20at%20sunset%2C%20soft%20amber%20and%20cream%20tones%2C%20tender%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-m4-banner&orientation=landscape",
    tags: ["公路剧情", "温暖治愈", "平凡人物"],
    popularity: 566000,
    updatedAt: "2025-03-20",
    featured: false,
  },
  {
    id: "m5",
    title: "假面舞会",
    channel: "电影",
    genres: ["爱情", "喜剧"],
    region: "中国大陆",
    year: 2025,
    score: 8.1,
    episodes: 1,
    episodeUnit: "部",
    updateStatus: "已上线",
    director: "轻喜剧社",
    cast: ["乔安安", "陆时", "苏眠"],
    synopsis: "一场要求戴面具参加的舞会，让两个互相看不顺眼的人，阴差阳错地遇见了真心。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20romantic%20vertical%20movie%20poster%20for%20a%20Chinese%20romantic%20comedy%2C%20glamorous%20masquerade%20ball%20with%20golden%20chandeliers%20and%20masked%20dancers%2C%20warm%20gold%20and%20rose%20tones%2C%20charming%20cinematic%20key%20art%2C%20high%20detail&width=600&height=900&seq=mgtv-m5-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20glamorous%20banner%20for%20a%20Chinese%20romantic%20comedy%20film%2C%20grand%20ballroom%20during%20a%20masquerade%20ball%20with%20golden%20chandeliers%20and%20masked%20dancers%2C%20warm%20gold%20and%20rose%20tones%2C%20charming%20festive%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-m5-banner&orientation=landscape",
    tags: ["浪漫喜剧", "轻松甜蜜", "高糖"],
    popularity: 649000,
    updatedAt: "2025-08-18",
    featured: false,
  },
  {
    id: "m6",
    title: "深海救援",
    channel: "电影",
    genres: ["灾难", "动作"],
    region: "中国大陆",
    year: 2025,
    score: 8.7,
    episodes: 1,
    episodeUnit: "部",
    updateStatus: "已上线",
    director: "惊涛",
    cast: ["江屿", "柯岩", "何初", "苏岸"],
    synopsis: "深海钻井平台突发危机，一支救援小队潜入黑暗深渊，与时间赛跑，只为把同伴带回家。",
    cover:
      "https://readdy.ai/api/search-image?query=Intense%20vertical%20disaster%20movie%20poster%20for%20a%20Chinese%20action%20film%2C%20deep%20sea%20diver%20silhouette%20before%20a%20towering%20oil%20rig%20in%20stormy%20waves%2C%20cold%20deep%20blue%20with%20fiery%20orange%20accents%2C%20dramatic%20cinematic%20key%20art%2C%20high%20detail&width=600&height=900&seq=mgtv-m6-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20intense%20banner%20for%20a%20Chinese%20disaster%20action%20film%2C%20dramatic%20stormy%20ocean%20with%20a%20huge%20offshore%20platform%20under%20menacing%20clouds%2C%20cold%20deep%20blue%20with%20fiery%20orange%20accents%2C%20epic%20tense%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-m6-banner&orientation=landscape",
    tags: ["灾难巨制", "紧张刺激", "深海"],
    popularity: 812000,
    updatedAt: "2025-09-12",
    featured: false,
  },
  {
    id: "m7",
    title: "山与海之间",
    channel: "电影",
    genres: ["剧情", "文艺"],
    region: "中国大陆",
    year: 2024,
    score: 8.3,
    episodes: 1,
    episodeUnit: "部",
    updateStatus: "已上线",
    director: "无风",
    cast: ["沈砚", "白露", "老陈"],
    synopsis: "海边小镇的一位老渔民和一个城市来的摄影师，在山与海之间，谈起了关于坚持与告别的事。",
    cover:
      "https://readdy.ai/api/search-image?query=Poetic%20minimalist%20vertical%20movie%20poster%20for%20a%20Chinese%20art%20drama%2C%20lone%20figure%20walking%20on%20a%20misty%20shore%20where%20mountains%20meet%20the%20sea%2C%20muted%20blue%20grey%20and%20soft%20green%20tones%2C%20contemplative%20cinematic%20key%20art&width=600&height=900&seq=mgtv-m7-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20poetic%20minimalist%20banner%20for%20a%20Chinese%20art%20drama%20film%2C%20misty%20coastline%20where%20green%20mountains%20meet%20a%20calm%20sea%20at%20dawn%2C%20muted%20blue%20grey%20and%20soft%20green%20tones%2C%20contemplative%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-m7-banner&orientation=landscape",
    tags: ["文艺剧情", "小众佳作", "治愈"],
    popularity: 487000,
    updatedAt: "2025-02-14",
    featured: false,
  },
  {
    id: "m8",
    title: "最后一封信",
    channel: "电影",
    genres: ["温情", "家庭"],
    region: "中国大陆",
    year: 2025,
    score: 8.9,
    episodes: 1,
    episodeUnit: "部",
    updateStatus: "已上线",
    director: "拾光",
    cast: ["林知远", "柳如烟", "何静"],
    synopsis: "父亲留下的最后一封信，让事业受挫的女儿回到了阔别多年的小城，也找回了家的温度。",
    cover:
      "https://readdy.ai/api/search-image?query=Tender%20emotional%20vertical%20movie%20poster%20for%20a%20Chinese%20family%20drama%2C%20woman%20reading%20a%20handwritten%20letter%20by%20a%20sunlit%20window%20with%20soft%20curtains%2C%20warm%20cream%20and%20amber%20tones%2C%20heartfelt%20cinematic%20key%20art%2C%20high%20detail&width=600&height=900&seq=mgtv-m8-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20tender%20banner%20for%20a%20Chinese%20family%20drama%20film%2C%20sunlit%20old%20house%20room%20with%20a%20window%20and%20warm%20dust%20motes%2C%20warm%20cream%20and%20amber%20tones%2C%20heartfelt%20nostalgic%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-m8-banner&orientation=landscape",
    tags: ["家庭温情", "催泪治愈", "亲情"],
    popularity: 758000,
    updatedAt: "2025-09-16",
    featured: true,
  },
  {
    id: "a1",
    title: "星海少年团",
    channel: "动漫",
    genres: ["热血", "冒险"],
    region: "中国大陆",
    year: 2025,
    score: 8.7,
    episodes: 26,
    episodeUnit: "话",
    updateStatus: "更新至第26话",
    director: "绘星社",
    cast: ["声优阵容"],
    synopsis: "五位性格迥异的少年组成探险团，驾驶星舰驶向未知星海，只为寻找传说中的家园坐标。",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20anime%20vertical%20poster%20for%20a%20Chinese%20space%20adventure%20animation%2C%20group%20of%20young%20heroes%20before%20a%20glowing%20star%20map%20and%20spaceship%2C%20vivid%20cyan%20orange%20and%20purple%20galaxy%20colors%2C%20high%20energy%20anime%20key%20art%2C%20high%20detail&width=600&height=900&seq=mgtv-a1-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20vibrant%20anime%20banner%20for%20a%20Chinese%20space%20adventure%20animation%2C%20colorful%20nebula%20with%20a%20sleek%20spaceship%20and%20glowing%20planets%2C%20vivid%20cyan%20orange%20and%20purple%20colors%2C%20high%20energy%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-a1-banner&orientation=landscape",
    tags: ["热血冒险", "国漫精品", "少年成长"],
    popularity: 668000,
    updatedAt: "2025-10-01",
    featured: false,
  },
  {
    id: "a2",
    title: "云端小镇",
    channel: "动漫",
    genres: ["治愈", "日常"],
    region: "中国大陆",
    year: 2024,
    score: 8.5,
    episodes: 20,
    episodeUnit: "话",
    updateStatus: "更新至第20话",
    director: "软云社",
    cast: ["声优阵容"],
    synopsis: "漂浮在云朵之上的小镇里，住着会做甜点的少女和一群奇怪的邻居，每天都是慢悠悠的小确幸。",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20anime%20vertical%20poster%20for%20a%20healing%20daily%20life%20animation%2C%20girl%20in%20a%20cozy%20bakery%20on%20a%20floating%20cloud%20town%2C%20fluffy%20clouds%20and%20pastel%20bakery%20treats%2C%20gentle%20cream%20pink%20and%20sky%20blue%20tones%2C%20high%20detail%20anime%20key%20art&width=600&height=900&seq=mgtv-a2-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20soft%20pastel%20anime%20banner%20for%20a%20healing%20daily%20life%20animation%2C%20floating%20cloud%20town%20with%20cozy%20houses%20and%20fluffy%20clouds%2C%20gentle%20cream%20pink%20and%20sky%20blue%20tones%2C%20peaceful%20dreamy%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-a2-banner&orientation=landscape",
    tags: ["治愈日常", "软萌画风", "轻松下饭"],
    popularity: 533000,
    updatedAt: "2025-06-10",
    featured: false,
  },
  {
    id: "a3",
    title: "机械纪元",
    channel: "动漫",
    genres: ["科幻", "机甲"],
    region: "中国大陆",
    year: 2025,
    score: 8.6,
    episodes: 24,
    episodeUnit: "话",
    updateStatus: "更新至第24话",
    director: "钢核studio",
    cast: ["声优阵容"],
    synopsis: "在被机械统治的世界里，一名少年驾驶着古老机甲，为人类最后的自由而战。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20mecha%20anime%20vertical%20poster%20for%20a%20sci%20fi%20Chinese%20animation%2C%20pilot%20before%20a%20towering%20battle%20mecha%20in%20a%20ruined%20future%20city%2C%20glowing%20cyan%20thrusters%20and%20warm%20sparks%2C%20steel%20grey%20and%20fiery%20orange%20tones%2C%20high%20detail%20anime%20key%20art&width=600&height=900&seq=mgtv-a3-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20dark%20mecha%20anime%20banner%20for%20a%20sci%20fi%20Chinese%20animation%2C%20towering%20battle%20mecha%20before%20a%20ruined%20future%20city%20at%20dusk%20with%20glowing%20thrusters%2C%20steel%20grey%20and%20fiery%20orange%20tones%2C%20epic%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-a3-banner&orientation=landscape",
    tags: ["机甲科幻", "热血战斗", "国漫崛起"],
    popularity: 601000,
    updatedAt: "2025-09-26",
    featured: false,
  },
  {
    id: "g1",
    title: "舌尖的四季",
    channel: "纪录片",
    genres: ["美食", "人文"],
    region: "中国大陆",
    year: 2025,
    score: 9.2,
    episodes: 8,
    episodeUnit: "集",
    updateStatus: "更新至第8集",
    director: "味道团队",
    cast: ["旁白讲述"],
    synopsis: "跟随二十四节气的脚步，走遍大江南北，用一道道应季美食，讲述中国人与土地的深情。",
    cover:
      "https://readdy.ai/api/search-image?query=Appetizing%20documentary%20vertical%20poster%20about%20Chinese%20seasonal%20cuisine%2C%20rustic%20harvest%20table%20with%20steaming%20seasonal%20dishes%20and%20fresh%20ingredients%2C%20warm%20earthy%20terracotta%20and%20green%20tones%2C%20high%20detail%20food%20photography%20key%20art&width=600&height=900&seq=mgtv-g1-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20appetizing%20documentary%20banner%20about%20Chinese%20seasonal%20cuisine%2C%20golden%20farmland%20and%20rustic%20kitchen%20with%20steaming%20dishes%20at%20harvest%2C%20warm%20earthy%20terracotta%20and%20green%20tones%2C%20high%20detail&width=1600&height=900&seq=mgtv-g1-banner&orientation=landscape",
    tags: ["美食纪录片", "人文四季", "高口碑"],
    popularity: 792000,
    updatedAt: "2025-09-14",
    featured: true,
  },
  {
    id: "g2",
    title: "大地脉动",
    channel: "纪录片",
    genres: ["自然", "生态"],
    region: "中国大陆",
    year: 2024,
    score: 9.0,
    episodes: 6,
    episodeUnit: "集",
    updateStatus: "更新至第6集",
    director: "自然志",
    cast: ["旁白讲述"],
    synopsis: "从雪山到海洋，从密林到草原，镜头记录下这片土地上最壮阔的生命迁徙与四季轮回。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20nature%20documentary%20vertical%20poster%2C%20herd%20of%20wild%20animals%20crossing%20a%20vast%20golden%20savanna%20at%20sunrise%20with%20distant%20snow%20mountains%2C%20rich%20natural%20earth%20tones%2C%20high%20detail%20cinematic%20wildlife%20key%20art&width=600&height=900&seq=mgtv-g2-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20epic%20nature%20documentary%20banner%2C%20vast%20snow%20mountains%20meeting%20green%20grassland%20at%20sunrise%20with%20migrating%20animals%2C%20rich%20natural%20earth%20tones%2C%20majestic%20high%20detail%20wildlife%20atmosphere&width=1600&height=900&seq=mgtv-g2-banner&orientation=landscape",
    tags: ["自然生态", "视觉震撼", "科普"],
    popularity: 685000,
    updatedAt: "2025-05-08",
    featured: false,
  },
  {
    id: "g3",
    title: "匠人之路",
    channel: "纪录片",
    genres: ["人物", "纪实"],
    region: "中国大陆",
    year: 2025,
    score: 8.9,
    episodes: 10,
    episodeUnit: "集",
    updateStatus: "更新至第10集",
    director: "匠心纪录",
    cast: ["旁白讲述"],
    synopsis: "走进一位位民间匠人的工作间，看他们用一双手、一辈子，守住一门快要被遗忘的手艺。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20documentary%20vertical%20poster%20about%20Chinese%20traditional%20craftsmen%2C%20elderly%20artisan%20working%20by%20hand%20in%20a%20sunlit%20wooden%20workshop%20surrounded%20by%20tools%2C%20warm%20wood%20and%20amber%20tones%2C%20high%20detail%20editorial%20key%20art&width=600&height=900&seq=mgtv-g3-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20warm%20documentary%20banner%20about%20Chinese%20traditional%20craftsmen%2C%20sunlit%20wooden%20workshop%20with%20handmade%20crafts%20and%20tools%2C%20warm%20wood%20and%20amber%20tones%2C%20handcrafted%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=mgtv-g3-banner&orientation=landscape",
    tags: ["人物纪实", "匠心精神", "感动"],
    popularity: 522000,
    updatedAt: "2025-08-06",
    featured: false,
  },
];

export const channels = [
  { type: "电视剧", icon: "ri-tv-2-line", desc: "都市、古装、悬疑、青春多类型剧集，追剧不迷路。" },
  { type: "综艺", icon: "ri-emotion-happy-line", desc: "音乐、美食、旅行、脱口秀，快乐随时在线。" },
  { type: "电影", icon: "ri-film-line", desc: "科幻、悬疑、爱情、剧情，大银幕级观影体验。" },
  { type: "动漫", icon: "ri-magic-line", desc: "热血、治愈、机甲国漫，承包你的快乐时光。" },
  { type: "纪录片", icon: "ri-earth-line", desc: "自然、人文、美食、纪实，看见更大的世界。" },
];

export const regions = ["全部", "中国大陆", "中国香港", "中国台湾", "海外"];
export const years = ["全部", "2025", "2024", "2023", "2022"];
export const sorts = [
  { key: "hot", label: "热度" },
  { key: "update", label: "最新更新" },
  { key: "score", label: "评分" },
];